/**
 * Manager core
 */

window.HE.Manager = (function Manager($, HE)
{
	"use strict";
	var manager = {};
	return manager;
}(jQuery, window.HE || {}));
